
import { defineComponent } from 'vue'
import head from 'lodash/head'
import { getters, GetterTypes } from '@/store/modules/techpacks/techpacks.getters'
import { TechpackRowItem } from '@/store/modules/techpacks/techpacks.model'
import TechpacksList from '../components/TechpacksList.vue'

export default defineComponent({
  name: 'FolderDetails',
  components: {
    TechpacksList
  },
  computed: {
    techpacks(): Array<TechpackRowItem> {
      return getters[GetterTypes.GET_FOLDER_TECHPACKS](this.$store.state.techpacks)(this.$route.params.folderId)
    },
    folderName(): string {
      const tp = head(this.techpacks)
      return tp?.folderName || 'Folder Techpacks'
    },
    techpacksLoading(): boolean {
      return this.$store.state.techpacks.loading
    }
  }
})
